import { LegendLabel } from '../../types/chart';

type ChartLegendProps = {
  labels: LegendLabel[];
};

function ChartLegend({ labels }: ChartLegendProps) {
  return (
    <ul className="flex justify-center gap-4 mt-8">
      {labels.map((label, index) =>
        index === 2 ? (
          <li key={index} className="flex items-center gap-2">
            <div
              className="h-1 w-4"
              style={{ backgroundColor: label.color }}
            ></div>
            <span className='text-sm font-normal'>{label.text}</span>
          </li>
        ) : (
          <li key={index} className="flex items-center gap-2">
            <div
              className="relative h-1 w-4 before:absolute before:left-1/2 before:top-1/2 before:h-2 before:w-2 before:translate-x-[-50%] before:translate-y-[-50%] before:rounded-full before:bg-inherit"
              style={{ backgroundColor: label.color }}
            ></div>
            <span className='text-sm font-normal'>{label.text}</span>
          </li>
        ),
      )}
    </ul>
  );
}

export default ChartLegend;
